import { useCallback, useEffect, useState } from "react";

import { getDeviceLink } from "@/lib/device/device-link";
import type { OfflineDeviceLink } from "@/lib/offline/db";

/**
 * Reads the shared-device → nursery link from IndexedDB. `refresh` is called by
 * the setup/reset flows to re-evaluate which screen the login route shows.
 */
export function useDeviceLink() {
  const [link, setLink] = useState<OfflineDeviceLink | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const current = await getDeviceLink();
      setLink(current);
    } catch {
      // Treat an unreadable store as "not linked" rather than leaving the login
      // route stuck on its loading gate — that gate decides the screen for every
      // device, so a rejected read would otherwise be a permanent spinner.
      setLink(undefined);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { link, isLoading, refresh };
}
